import { c as _c } from "react/compiler-runtime";
import { Icon } from '@repo/design-system/components/ds/icon';
import { FlexColumn } from '@repo/design-system/components/layout/flex-column';
import { FlexRow } from '@repo/design-system/components/layout/flex-row';
import { ContextMenu } from '@repo/design-system/components/ui/context-menu';
import { Type } from '@repo/design-system/components/ui/type';
import type { ThemeColorValue } from '@repo/design-system/utils/theme-utils';
import { css } from '@repo/panda/css';
import type React from 'react';
import { SubcategoryCardImage } from './subcategory-card-image';
interface ChecklistCardProps {
  imageUrl: string | null;
  icon: React.ReactNode;
  title: string;
  foundCount: number;
  totalCount: number;
  onClick?: () => void;
  titleColor?: ThemeColorValue;
  /** When provided, the card is wrapped in a ContextMenu with these items on right-click. */
  contextMenuItems?: React.ReactNode;
}
export const ChecklistCard: React.FC<ChecklistCardProps> = t0 => {
  const $ = _c(32);
  const {
    imageUrl,
    icon,
    title,
    foundCount,
    totalCount,
    onClick,
    titleColor: t1,
    contextMenuItems
  } = t0;
  const titleColor = t1 === undefined ? "white" : t1;
  const interactive = !!onClick;
  let t2;
  if ($[0] !== interactive) {
    t2 = css.raw({
      padding: "16",
      height: "[64px]",
      backgroundColor: "whiteAlpha.5",
      borderRadius: "12",
      cursor: interactive ? "pointer" : "default",
      overflow: "hidden",
      position: "relative",
      backdropFilter: "[blur(16px)]",
      _hover: interactive ? {
        backgroundColor: "whiteAlpha.10"
      } : {}
    });
    $[0] = interactive;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = interactive ? "button" : undefined;
  let t4;
  if ($[2] !== interactive || $[3] !== onClick) {
    t4 = interactive ? e => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        e.stopPropagation();
        onClick?.();
      }
    } : undefined;
    $[2] = interactive;
    $[3] = onClick;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = interactive ? 0 : undefined;
  let t6;
  if ($[5] !== imageUrl) {
    t6 = <SubcategoryCardImage imageUrl={imageUrl} />;
    $[5] = imageUrl;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = css.raw({
      position: "relative",
      zIndex: "1"
    });
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== title || $[9] !== titleColor) {
    t8 = <Type variant="body-s" color={titleColor} truncate={true} title={title}>{title}</Type>;
    $[8] = title;
    $[9] = titleColor;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== foundCount || $[12] !== totalCount) {
    t9 = totalCount > 0 && foundCount === totalCount ? <Icon icon="check_circle" size="sm" className={css({
      color: "brand.primary",
      minWidth: "fit",
      marginLeft: "auto"
    })} decorative={true} /> : <Type variant="body-xs" color="text.secondary" minWidth="fit" marginLeft="auto">{foundCount} / {totalCount}</Type>;
    $[11] = foundCount;
    $[12] = totalCount;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== icon || $[15] !== t8 || $[16] !== t9) {
    t10 = <FlexRow gap="32" align="center" width="full" className={t7}>{icon}{t8}{t9}</FlexRow>;
    $[14] = icon;
    $[15] = t8;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== onClick || $[19] !== t10 || $[20] !== t2 || $[21] !== t3 || $[22] !== t4 || $[23] !== t5 || $[24] !== t6 || $[25] !== title) {
    t11 = <FlexColumn width="full" title={title} className={t2} justify="center" role={t3} onClick={onClick} onKeyDown={t4} tabIndex={t5}>{t6}{t10}</FlexColumn>;
    $[18] = onClick;
    $[19] = t10;
    $[20] = t2;
    $[21] = t3;
    $[22] = t4;
    $[23] = t5;
    $[24] = t6;
    $[25] = title;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  const card = t11;
  if (!contextMenuItems) {
    return card;
  }
  let t12;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = css({
      width: "full"
    });
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== card || $[29] !== contextMenuItems || $[30] !== t12) {
    t13 = <ContextMenu triggerClassName={t12} trigger={card}>{contextMenuItems}</ContextMenu>;
    $[28] = card;
    $[29] = contextMenuItems;
    $[30] = t12;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  return t13;
};